/*
 * layout (root)
 */
import { createRootRoute, Link, Outlet } from "@tanstack/react-router"
import { Container, Header, Page } from "@psychology/react-ui"
import i18n from "i18next"
import { useTranslation } from "react-i18next"
import appCss from "../global.css?url"
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"
import Layout from "../layout"
import Providers from "../providers"
import { supabase } from "@psychology/auth/client"

function RootLayout() {
	const { user } = Route.useLoaderData()

	return (
		<Providers>
			<Layout user={user}>
				<Outlet />
				{/* <TanStackRouterDevtools
						initialIsOpen={false}
						position={"bottom-right"}
					/> */}
			</Layout>
		</Providers>
	)
}

export const Route = createRootRoute({
	head: () => ({
		meta: [
			{ charSet: "utf-8" },
			{ name: "viewport", content: "width=device-width, initial-scale=1" },
			{ title: i18n.t("head.title") },
		],
		links: [{ rel: "stylesheet", href: appCss }],
	}),
	loader: async () => {
		const { data, error } = await supabase.auth.getSession()
		if (error) {
			console.error("Auth getSession Error", { error })
		}

		return { user: data?.session?.user }
	},
	component: RootLayout,
	notFoundComponent: NotFoundPage,
})

function NotFoundPage() {
	const { t } = useTranslation()
	return (
		<Page>
			<Container className={"justify-center"}>
				<Header>{t("common.pageNotFound")}</Header>
				<p>{t("common.pageNotFoundDescription")}</p>
				<span>
					<Link to={"/"}>{t("common.goHome")}</Link>
				</span>
			</Container>
		</Page>
	)
}
